import { FormGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BackgroundImageField } from '../../../components/panels/LayoutPanel/BackgroundImageField';
import { Trait } from '../utils/Trait';

export function ColumnWidgetTraits() {
  const { t } = useTranslation();

  return (
    <FormGroup>
      <Trait>
        <BackgroundImageField
          name="attributes.backgroundImage"
          label={t('editor.layout.global.backgroundImage')}
        />
      </Trait>
    </FormGroup>
  );
}
